// extracted by mini-css-extract-plugin
module.exports = {"modal":"AppModal_modal__2rbpZ","phone-header-wrapper":"AppModal_phone-header-wrapper__1sONK"};